import React from "react";
import { Box, Typography, Paper, Grid, Tooltip, alpha } from "@mui/material";
import dayjs from "dayjs";

// Function to return color based on lead status
const getColor = (status: string): string => {
  switch (status) {
    case "NEW LEAD":
    case "NEW":
      case "EXTERNAL" :
        case "HOLDING FOLDER":
          case "QUOTE PENDING":
            case "DEBTOR":
      return "#FF66C4";
      case "STORAGE ENQ":
        return "#5500AA";
      case "STORAGE":
      return "#6aa84f";
    case "ESTIMATES":
      return "#D16B2C";
    case "SURVEY":
      return "#7ED957";
      case "SURVEYED":
        return "#00FFFF";
    case "PENDING":
      return "#FFBB23";
    case "IN PROGRESS":
    case "STARTED":
      return "#3174AD";
    case "COMPLETED":
    case "Completed":
      return "#008e73";
    case "QUOTE":
      return "#FF3131";
    case "CONFIRMED":
      return "#7C3014";
    case "JOB":
      return "#a52a2a";
    case "PROVISIONAL":
      return "#FFFF00";
      case "ARCHIVED":
      return "#666666";
      case "AWAITING":
      return "#0066ff";
    default:
      return "#000000";
  }
};

interface LeadListCardProps {
  lead: any;
  selectedLead: any;
  setGenerateId?: any;
  setSelectedLead?: any;
  value?: any;
}

const LeadListCard: React.FC<LeadListCardProps> = ({
  lead,
  selectedLead,
  setGenerateId,
  setSelectedLead,
  value,
}) => {

   // 🔹 Custom display status logic
  const displayStatus =
    lead?.status === "SURVEY" && lead?.survey_status === "COMPLETED"
      ? "SURVEYED"
      : lead?.status;

  const dateData = [
    {
      label: "F",
      fullLabel: "Follow Up Date",
      date: lead?.follow_up_date,
      color: "#FF4C4C",
    }, // red
    {
      label: "A",
      fullLabel: "Created At",
      date: lead?.created_at,
      color: "#339DFF",
    }, // blue
    {
      label: "M",
      fullLabel: "Moving On Date",
      date: lead?.moving_on_date,
      color: "#2DBE60",
    }, // green
    {
      label: "L",
      fullLabel: "Last Updated",
      date: lead?.updated_at,
      color: "#FF934F",
    }, // orange
  ];

  const formatShortDate = (dateString: string) => {
    if (!dateString) return "--";
    return dayjs(dateString).format("DD\nMMM").toUpperCase(); // like 01JAN
  };

  const formatFullDate = (dateString: string) => {
    if (!dateString) return "--";
    return dayjs(dateString).format("DD MMMM YYYY"); // like 01 January 2025
  };

  return (
    <Paper
      elevation={1}
      sx={{
        border: `1px solid ${
          selectedLead === lead.generated_id
            ? lead?.status === "COMPLETED" && value === "0"
              ? "#F5F5DC"
              : getColor(displayStatus)
            : "#ddd"
        }`,
        display: "flex",
        alignItems: "center",
        p: "2px",
        // borderRadius: "10px",
        backgroundColor: `${
          selectedLead === lead?.generated_id
            ? lead?.status === "COMPLETED" && value === "0"
              ? "#F5F5DC"
              : alpha(getColor(displayStatus), 0.15)
            : "#fff"
        }`,
        position: "relative",
        overflow: "hidden",
        // minWidth: 300,
        marginBottom: "4px",
        maxHeight: "100vh",
        cursor: "pointer",
        // maxWidth:300,
      }}
      onClick={() => {
        setGenerateId(lead?.generated_id);
        setSelectedLead(lead?.generated_id);
      }}
    >
      {/* Left Red Accent */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 10,
          backgroundColor:
            lead?.status === "COMPLETED" && value === "0"
              ? "#F5F5DC"
              : getColor(displayStatus),
          // borderTopLeftRadius: "10px",
          // borderBottomLeftRadius: "10px",
        }}
      />

      {/* Content */}
      <Box sx={{ ml: 2, width: "100%" }}>
        <Grid container spacing={0}>
          <Grid item xs={5.5}>
            <Typography
              variant="body2"
              fontWeight={600}
              sx={{ lineHeight: 1.5, textTransform: "capitalize" }}
            >
            {lead?.customer_prefix ? `${lead.customer_prefix} - ` : ""}{lead?.customer_name}
            </Typography>
          </Grid>

          {dateData.map((item, index) => (
            <Grid
              key={index}
              item
              xs
              sx={{ padding: "2px 4px", textAlign: "center", display: "block" }}
            >
              {/* <Tooltip
                title={`${item.fullLabel} - ${formatFullDate(item.date)}`}
                arrow
              >
                <Typography
                  variant="body2"
                  align="center"
                  fontWeight={500}
                  sx={{ color: "#000" }}
                >
                  {item.label}
                </Typography>
              </Tooltip> */}
              <Tooltip
                title={`${item.fullLabel} - ${formatFullDate(item.date)}`}
                arrow
              >
                <Typography
                  variant="body2"
                  align="center"
                  fontWeight={600}
                  sx={{
                    color: item.color,
                    fontSize: "12px",
                    display: "table-caption",
                  }}
                >
                  {item?.date ? formatShortDate(item.date) : "  -"}
                </Typography>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default LeadListCard;
